(() => {
  if (window.bbSeoEventsInitialized) return;
  window.bbSeoEventsInitialized = true;
  const publish = (name, method) => {
    const api = window.Shopify && window.Shopify.analytics;
    if (!api || typeof api.publish !== 'function') return;
    try {
      const result = api.publish(name, { method, page_path: window.location.pathname });
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (_) {}
  };
  document.addEventListener('click', (event) => {
    if (!event.target || typeof event.target.closest !== 'function') return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (href.startsWith('tel:')) publish('baby_beaks:enquiry_click', 'phone');
    else if (href.startsWith('mailto:')) publish('baby_beaks:enquiry_click', 'email');
    else {
      try {
        const url = new URL(href, window.location.href);
        if (url.hostname === 'docs.google.com' && url.pathname.startsWith('/forms/')) publish('baby_beaks:waitlist_click', 'waitlist');
      } catch (_) {}
    }
  });
})();

